import { makeStyles } from '@material-ui/core';
import { neutral } from '../../../../shared/styles/colors';

export default makeStyles(() => ({
  root: {
    alignItems: 'center',
    background: neutral.white,
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'flex-end',
  },
  editOrderButton: {
    color: neutral[100],
    textDecoration: 'underline',
  },
  acceptOrderBtn: {
    padding: '0.75rem 1rem',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    borderRadius: '0.5rem',
    color: neutral.white,
    backgroundColor: neutral[90],
    border: `1px solid ${neutral[90]}`,
    '&:hover': {
      color: neutral['20'],
      backgroundColor: neutral[100],
      border: `1px solid ${neutral[100]}`,
    },
  },
}));
